import LandOgUniversitetModel from '../../Shared/Scripts/Models/LandOgUniversitetModel';

export const hentUniversiteter = async (id: string): Promise<Array<LandOgUniversitetModel>> => {
    const response = await fetch(`/api/mt1535/satser/utlandutveksling/${id}`);

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};